import { HttpRequest, HttpMethod } from "./http";

class StorefrontProvider extends HttpRequest {
    // ----- Hero carousel -----
    listHero() {
        return this.request(HttpMethod.Get, "/api/v1/bo/storefront/hero");
    }

    createHero(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/storefront/hero", payload);
    }

    updateHero(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/storefront/hero/${id}`, payload);
    }

    removeHero(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/storefront/hero/${id}`);
    }

    // ----- First-visit popups (multi-row, single-active #59) -----
    listPopup() {
        return this.request(HttpMethod.Get, "/api/v1/bo/storefront/popup");
    }

    createPopup(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/storefront/popup", payload);
    }

    updatePopup(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/storefront/popup/${id}`, payload);
    }

    removePopup(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/storefront/popup/${id}`);
    }

    activatePopup(id) {
        return this.request(HttpMethod.Post, `/api/v1/bo/storefront/popup/${id}/activate`);
    }

    // ----- Checkout policy settings (COD pending limit, issue #181) -----
    getCheckoutSettings() {
        return this.request(HttpMethod.Get, "/api/v1/bo/settings/checkout");
    }

    updateCheckoutSettings(payload) {
        return this.request(HttpMethod.Put, "/api/v1/bo/settings/checkout", payload);
    }

    // ----- Cash Back config (shop-level default + master switch, issue #654) -----
    // Same envelope as the checkout settings above: {data: {enabled, default_percent}}.
    // PUT is admin-only on the API (mw.IsAdmin) and accepts a PARTIAL body — send
    // only the field being changed and the other keeps its stored value.
    getCashbackSettings() {
        return this.request(HttpMethod.Get, "/api/v1/bo/settings/cashback");
    }

    updateCashbackSettings(payload) {
        return this.request(HttpMethod.Put, "/api/v1/bo/settings/cashback", payload);
    }

    // ----- App version policy / force update (asrth/mdf-app#205, T-017) -----
    // {data: {android: {min_version, latest_version, store_url}, ios: {...},
    //  message_th, message_en, updated_at}}. PUT is admin-only (mw.IsAdmin);
    // every leaf optional, "" clears it.
    getAppVersionSettings() {
        return this.request(HttpMethod.Get, "/api/v1/bo/settings/app-version");
    }

    updateAppVersionSettings(payload) {
        return this.request(HttpMethod.Put, "/api/v1/bo/settings/app-version", payload);
    }

    // ----- MDFStore sale-channel mapping (per-source: web / member / app) -----
    // NOTE: path pending contract sync with Dev-BE2 (feat/sale-channel-source-mapping).
    // GET returns the current mapping + the list of selectable sale channels
    // (options are MDFStore platform channels only, platform_id = 9).
    getMdfstoreChannelMapping() {
        return this.request(HttpMethod.Get, "/api/v1/bo/settings/mdfstore-sale-channel");
    }

    updateMdfstoreChannelMapping(payload) {
        return this.request(HttpMethod.Put, "/api/v1/bo/settings/mdfstore-sale-channel", payload);
    }
}

export default StorefrontProvider;
